// v3.12.10: ClockContext isolates live clock updates from the full component tree.
// Only components that read useContext(ClockContext) re-render every second.
// Previously, DesktopUI's useState(new Date()) + setInterval triggered full-tree re-renders (180KB component).
import React, { createContext, useContext, useState, useEffect } from 'react';

const ClockContext = createContext<Date>(new Date());

export function ClockProvider({ children }: { children: React.ReactNode }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const timer = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(timer);
  }, []);

  return React.createElement(ClockContext.Provider, { value: now }, children);
}

export function useClock(): Date {
  return useContext(ClockContext);
}
